function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;} // Empty2DModelLoader - Loader for an empty 2D scene.
export var Empty2DModelLoader = /*#__PURE__*/function () {
  function Empty2DModelLoader(viewer3DImpl) {_classCallCheck(this, Empty2DModelLoader);
    this.viewer3DImpl = viewer3DImpl;
  }_createClass(Empty2DModelLoader, [{ key: "loadFile", value: function loadFile(

    url) {var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};var onDone = arguments.length > 2 ? arguments[2] : undefined;var onWorkerStart = arguments.length > 3 ? arguments[3] : undefined;
      var width = options.width || 100;
      var height = options.height || 100;

      onWorkerStart && onWorkerStart();

      this.svf = {
        is2d: true,
        viewports: [],
        layersMap: { "0": 0 },
        layerCount: 1,
        bbox: new THREE.Box3(new THREE.Vector3(0, 0, 0),
        new THREE.Vector3(width, height, 0)),
        fragments: {
          length: 1,
          fragId2dbId: [0],
          dbId2fragId: {},
          transforms: new Float32Array(12),
          boxes: [0, 0, 0, width, height, 0] },

        loadOptions: {
          bubbleNode: new Autodesk.Viewing.BubbleNode({
            urn: 'Dummy_urn',
            guid: 'Dummy_guid' }) },


        metadata: {
          page_dimensions: {
            page_width: width,
            page_height: height,
            logical_width: width,
            logical_height: height,
            logical_offset_x: 0,
            logical_offset_y: 0,
            page_units: "inch" } },


        strings: [],
        stringDbIds: [],
        loadDone: true };


      var model = new Autodesk.Viewing.Model(this.svf);

      model.initialize();
      model.loader = this;
      this.model = model;
      onDone(null, model);
      this.viewer3DImpl.api.dispatchEvent({ type: Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT, svf: this.svf, model: model });
      this.viewer3DImpl.onLoadComplete(model);
    } }, { key: "dtor", value: function dtor()

    {} }, { key: "is2d", value: function is2d()
    {return true;} }, { key: "is3d", value: function is3d()
    {return false;} }]);return Empty2DModelLoader;}();